import React from 'react'
import classes from './styles.module.scss'
import classNames from 'classnames'

interface TooltipProps {
  children: React.ReactNode
  text: string
  position?: 'top' | 'bottom' | 'left' | 'right'
  disabled?: boolean
}

export const Tooltip: React.FC<TooltipProps> = (props) => {
  const { children, text, position = 'top', disabled = false } = props

  if (disabled) return children

  return (
    <div className={classes.tooltip} aria-label={text}>
      {children}
      <span
        className={classNames({
          [classes.tooltip__text]: true,
          [classes[`tooltip__text--${position}`]]: true,
        })}
        aria-hidden
        role="tooltip"
      >
        {text.split('\n').map((line, i) => (
          <React.Fragment key={i}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </span>
    </div>
  )
}